import React from "react";
import BottomFixedModal from "@src/components/common/bottomFixedModal/BottomFixedModal";
import './slotSortOptionsBottomSheet.scss';
import { SortOptionDefaultType, SortOptionType } from "@src/types/weddingHall";
import { createPortal } from "react-dom";

type Props = {
  sortOptions:object;
  isShow: boolean;
  closeSheet: (value: React.SetStateAction<boolean>) => void;
  changeOption: (value)=>void;
  sortType: SortOptionType | SortOptionDefaultType | null;
  setFilterChips: (value)=>void;
};

export const SortOptionsBottomSheet = ({sortOptions, isShow,closeSheet,changeOption,sortType,setFilterChips}: Props) => {

  return (
		createPortal(
    <BottomFixedModal 
      isShow={isShow} title={""} isTransition={true} hideModal={() => closeSheet(false)}
      className="slot-sort-option-sheet">
        <ul className="sort-options-wrap">
          { Object.entries(sortOptions).map(option =>
          <li 
            key={`orderby-${option[0]}`}
            className={`${sortType === option[0] ? 'active' : ''}`}
            onClick={()=>{
              changeOption(option[0])
              setFilterChips((prevChips)=>{
                const updatedChip = {...prevChips[0], value:option[1]};
                let newChips = prevChips;
                newChips[0] = updatedChip;
                return newChips
              })
              closeSheet(false);
            }}>
              <span>{option[1]}</span>
            {sortType === option[0] && <i className="icon icon-checkmark-brown500"/>}
          </li>
          )}
        </ul>
    </BottomFixedModal>, document.body)
  );
}

export default SortOptionsBottomSheet;